import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import ChangeGroupModal from 'modules/permissions/components/ChangeGroupModal'

const ExternalsChangeGroupPageModalPage = () => {
  const { navigation } = useNavigation()
  const { id, userId } = useStrictParams<'id' | 'userId'>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.permissions.id.externals.fullPath({ id }))
  }

  return <ChangeGroupModal onClose={onClose} userId={String(userId)} />
}

export default ExternalsChangeGroupPageModalPage
